import React from 'react'

export default () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="kriterier-og-search-copy"
        transform="translate(-250.000000, -28.000000)"
      >
        <g id="kriterier-og-search">
          <g
            id="icon/search_normal"
            transform="translate(251.000000, 29.000000)"
          >
            <g>
              <path
                d="M16.4489454,8.22450923 C16.4489454,12.766738 12.7667461,16.4490185 8.22443616,16.4490185 C3.68220738,16.4490185 8.11808118e-06,12.766738 8.11808118e-06,8.22450923 C8.11808118e-06,3.68228044 3.68220738,0 8.22443616,0 C12.7667461,0 16.4489454,3.68228044 16.4489454,8.22450923 Z"
                id="Stroke-1"
                strokeWidth="2"
              />
              <path
                d="M14.0181483,13.9784103 L21.9704583,21.9307203"
                id="Stroke-3"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/searchIcon.js